export default "__VITE_ASSET__CATJL8U8__"